import { NAME } from './constants';
import { apiProvider } from './api';
import { router } from './router';

export const PneuSklad = {
	name: NAME,
	apiProvider,
	router,
};
